<template>
    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                <div class="col-sm-2" v-if="webW">
                    <div id="JfLeftMenuOut">
                    <div  :class="(fixedLeftmenu?'fixedMenuCls':'')" :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''"  id="JfLeftMenu">
                        <div class="baiseback" style="min-height: 100vh">
                            <ForumLeft></ForumLeft>

                        </div>
                    </div>

                    <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                    </div>
                </div>
                <div :class="webW?'col-sm-7':'col-sm-12'" id="mainDiv">

                    <div class="baiseback"  v-if="tableDataloading">
                        <div class="center">
                            <img src="../../../assets/img/loading.gif">
                            <p class="typedesc">数据加载中....</p>
                        </div>
                    </div>
                    <div class="baiseback" style="height: 100vh;"  v-if="!tableDataloading&&tableData.length==0">
                        <div class="center">
                            <img src="../../../assets/img/zwsj.png">
                            <p class="typedesc">暂无数据</p>
                        </div>
                    </div>

                    <div  v-for="(t,i) in tableData" :key="i">

                        <div class="baiseback"  >

                            
                            <div>
                                <el-button style="float: right;" icon="el-icon-refresh" @click="goshuaxin" size="mini" >{{webW?'刷新':''}}</el-button>

                                <el-button style="float: right;" icon="el-icon-back" @click="goreaturn" size="mini" >{{webW?'返回上一页':''}}</el-button>

                                <h3 class="hh" :class="webW?'pctitle':'phonetitle'">{{t.ftitle}}<el-tag size = "mini" v-if="t.istop=='1'">置顶</el-tag><el-tag size = "mini" v-if="t.isbest=='1'" type="danger">收录</el-tag></h3>
                                <span class="hh hander"  @click="goUHome(t.authorUid)">
                                    <img :src="author.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                    <span :class="webW?'pcname':'phonename'" >{{author.uname}}</span>
                                </span>
                                <div class="h10"></div>
                                <p class=" typedesc">
                                    

                                    <span>发表于  {{t.cts}}</span><span v-if="t.editTs!=null&&t.editTs!=''">，最后编辑  {{t.editTs}}</span>

                                    <el-button class="pull-right" type="danger"   @click="delForumHandel" v-if="lander.uid==author.id" size="mini" ><span v-if="webW">删除</span><i class="fa fa-trash" v-else></i></el-button>
                                    <el-button class="pull-right" type="warning"   @click="editForumHandel" v-if="lander.uid==author.id||quanxian=='1'" size="mini"><span v-if="webW">编辑</span><i class="fa fa-edit" v-else></i></el-button>
                                </p>
                                <div class="h10"></div>

                                <div class="hh forumcont" v-html="t.fcontext"></div>

                                <div style="height: 10px;"></div>
                                <div class="upimgsidvone" v-if="t.imgsli!=null&&t.imgsli.length==1">
                                    <el-image :src="imgt" v-for="(imgt,imgindex) in t.imgsli"  :key="imgindex"  fit="contain" :preview-src-list="t.imgsli" ></el-image>
                                </div>

                                <div  class="upimgsidv" :style="'max-width:'+jiugonggeWidth+'px'" v-if="t.imgsli!=null&&t.imgsli.length>=2">
                                    <el-row>
                                        <el-col :span="8" v-for="(imgt,imgindex) in t.imgsli" :key="imgindex">
                                            <div class="itemdiv" :style="'width:'+jiugonggeItemWidth+'px;height:'+jiugonggeItemWidth+'px;'">
                                                <el-image :src="imgt"  class="upimgcls" fit="cover" :preview-src-list="t.imgsli" ></el-image>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>


                                <div class="upimgsidvone" v-if="t.videosli!=null&&t.videosli.length==1">
                                    <div  v-for="(vt,vindex) in t.videosli" :key="vindex">
                                        <video  @timeupdate="jiantingVideo" :src="vt.vurl"   :id="'videoitem_'+t.id" :data-index="i" :data-vindex="vindex" controls   :class="webW?'webbigvideo':'phonebigvideo'"></video>

                                    </div>
                                </div>

                                <div  v-if="t.videosli!=null&&t.videosli.length>=2">
                                    <div  v-show="t.nowvideo.isshow=='1'">
                                        <div>
                                            <video @timeupdate="jiantingVideo" :src="t.nowvideo.vurl"  :id="'videoitem_'+t.id"   :data-index="t.nowvideo.index" :data-vindex="t.nowvideo.vindex" controls class="bigvideo"   :class="webW?'webbigvideo':'phonebigvideo'"></video>

                                        </div>
                                        <el-row>
                                            <el-col :span="3"  v-for="(vt,vindex) in t.videosli" :key="vindex">
                                                <div style="padding: 2px;" :style="'height:'+(videoplayitemWidth)+'px;'">
                                                    <img @click="playvideo(t,i,vt,vindex)"  src="../../../assets/img/player0.png" v-if="vt.isplay=='0'" class="videozhechaoceng"   :style="'width:'+videoplayitemWidth+'px;height:'+videoplayitemWidth+'px;'"  >
                                                    <img @click="stopvideo()"  src="../../../assets/img/player1.png" v-if="vt.isplay=='1'" class="videozhechaoceng"   :style="'width:'+videoplayitemWidth+'px;height:'+videoplayitemWidth+'px;'"   >
                                                    <video  :src="vt.vurl"        :style="'width:'+videoplayitemWidth+'px;height:'+videoplayitemWidth+'px;background-color: #000;'"></video>
                                                </div>
                                            </el-col>
                                        </el-row>


                                    </div>
                                    <div   v-show="t.nowvideo.isshow=='0'" class="upimgsidv" :style="'max-width:'+jiugonggeWidth+'px'">
                                        <el-row>
                                            <el-col :span="8" v-for="(vt,vindex) in t.videosli" :key="vindex">
                                                <div class="itemdiv" :style="'width:'+jiugonggeItemWidth+'px;height:'+jiugonggeItemWidth+'px;'">
                                                    <img @click="playvideo2(t,i,vt,vindex)"  src="../../../assets/img/player0.png" v-if="vt.isplay=='0'" class="videozhechaoceng"  :style="'width:'+(jiugonggeItemWidth-1)+'px;height:'+(jiugonggeItemWidth-1)+'px;'"  >
                                                    <img @click="stopvideo()"  src="../../../assets/img/player1.png" v-if="vt.isplay=='1'" class="videozhechaoceng"  :style="'width:'+(jiugonggeItemWidth-1)+'px;height:'+(jiugonggeItemWidth-1)+'px;'"  >
                                                    <video   :src="vt.vurl"   :style="'width:'+jiugonggeItemWidth+'px;height:'+jiugonggeItemWidth+'px;background-color: #000;'"></video>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>

                                <div style="height: 10px;"></div>


                                <p class="typedesc"  v-if="t.isVote=='1'">可投票时间：{{t.vstartTs}} 到 {{t.vendTs}}
                                    <el-tag v-if="t.voteState=='0'" size="mini">未开始</el-tag>
                                    <el-tag v-if="t.voteState=='2'" type="danger"  size="mini">进行中</el-tag>
                                    <el-tag v-if="t.voteState=='1'"  size="mini">已结束</el-tag>
                                    <el-tag v-if="t.ivote=='1'" type="info"  size="mini">你已参与投票</el-tag>
                                </p>
                                <div v-if="t.isVote=='1' && t.vtype=='dx' && t.voteItemli.length>0">
                                    <div v-for="(tv,vi) in t.voteItemli" class="margintop20" :key="vi">
                                        <el-row>
                                            <el-col :span="12">
                                                <el-radio   @change="dxVoteHandle(t,i,tv,vi)" :label="tv.id" v-model="t.myvoteDx" :disabled="(t.voteState=='2'?false:true)||(t.ivote=='0'?false:true)" >{{tv.vitem}}</el-radio>
                                            </el-col>
                                            <el-col :span="12">
                                                <div style="text-align: right;">
                                                    <b class="toupiaob" v-if="t.vshowNum=='1'||t.authorUid==lander.uid">{{tv.peopleNum}}人</b>
                                                    <b class="toupiaob">{{tv.vpercentage}}%</b>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <div class="row margintop20" >
                                            <div class="col-sm-12"><div class="tpjdt"><div class="seltpjdut" :style="'width:'+tv.vpercentage+'%;'"></div></div> </div>

                                        </div>
                                        <div class="row margintop20"   v-if="(t.vshowPeople=='1'||t.authorUid==lander.uid)&&tv.votePeopleli.length>0">
                                            <div class="col-sm-12">
                                                <el-tooltip effect="dark" :content="tp.uname" placement="top-start" v-for="(tp, pi) in tv.votePeopleli" :key="pi">
                                                <img :src="tp.faceimg"   @click="goUHome(tp.voteUid)"  class="toupiaofaceimg hander">
                                                </el-tooltip>
                                                <span class="typedesc">...等用户投了一票</span><span @click="seeVotePeople(tv)"  class="hander seetiezi">【查看用户】</span></div>
                                        </div>
                                    </div>

                                </div>

                                <div v-if="t.isVote=='1' && t.vtype=='mx' && t.voteItemli.length>0">
                                    <el-checkbox-group v-model="t.myvoteMx" >
                                        <div v-for="(tv,vi) in t.voteItemli" class="margintop20" :key="vi">
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-checkbox :label="tv.id" :value="tv.id"  :disabled="(t.voteState=='2'?false:true)||(t.ivote=='0'?false:true)">{{tv.vitem}}</el-checkbox>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div style="text-align: right;">
                                                        <b class="toupiaob"  v-if="t.vshowNum=='1'||t.authorUid==lander.uid">{{tv.peopleNum}}人</b>
                                                        <b class="toupiaob" >{{tv.vpercentage}}%</b>
                                                    </div>

                                                </el-col>
                                            </el-row>



                                            <div class="row margintop20" >
                                                <div class="col-sm-12"><div class="tpjdt"><div class="seltpjdut" :style="'width:'+tv.vpercentage+'%;'"></div></div> </div>

                                            </div>
                                            <div class="row margintop20"  v-if="(t.vshowPeople=='1'||t.authorUid==lander.uid)&&tv.votePeopleli.length>0">
                                                <div class="col-sm-12">
                                                    <el-tooltip effect="dark" :content="tp.uname" placement="top-start" v-for="(tp,pi) in tv.votePeopleli" :key="pi">
                                                    <img :src="tp.faceimg"  @click="goUHome(tp.voteUid)"  class="toupiaofaceimg hander">
                                                    </el-tooltip>
                                                    <span class="typedesc">...等用户投了一票</span><span @click="seeVotePeople(tv)"  class="hander seetiezi">【查看用户】</span></div>
                                            </div>


                                        </div>
                                    </el-checkbox-group>

                                    <div class="center margintop20" v-if="t.ivote=='0'&&t.voteItemli.length>0">
                                        <el-button type="primary" @click="mxVoteHandle(t,i)"  :disabled="t.voteState=='2'?false:true">提交投票</el-button>
                                    </div>

                                </div>



                            </div>
                            
                            <div class="h20"></div>
                            <el-row class="teiziline">
                                <el-col :span="2" ><br></el-col>
                                <!-- <el-col :span="5"  ><p class=" typedesc center  "><i class="el-icon-view"></i>&nbsp;{{t.viewNum}}
                                </p></el-col> -->
                                <el-col :span="6"><p class=" typedesc center hander" ><i class="el-icon-chat-square"></i>&nbsp;{{t.commentNum}}
                                </p></el-col>
                                <el-col :span="6"><p class=" typedesc center hander" @click="hitHandle(t,i)">
                                       <i :class="'fa fa-thumbs-up '+(t.ishit=='1'?'seled':'')"></i>&nbsp;{{t.hitNum}}</p>
                                </el-col>
                                <el-col :span="5"><p class=" typedesc center hander" @click="collectHandle(t,i)"><i
                                        :class="'el-icon-star-off '+(t.iscollect=='1'?'seled':'')"></i>&nbsp;{{t.collectNum}}
                                </p></el-col>
                            </el-row>

                        </div>



                        <!--pl-->
                        <div class="fpldiv"    id="commentMain">
                            <!-- <el-switch  v-if="webW"
                                        @click="openAutoReflashCommentsFunc"
                                        style=" right: 10px;position: absolute;z-index: 1;margin-top: 10px;"
                                        active-text="下拉刷新"
                                        v-model="openAutoReflashComments"
                                        active-color="#13ce66"
                                        inactive-color="#dddddd">
                            </el-switch> -->
                            <el-tabs v-model="activeName"  @tab-click="tabClick">
                                <el-tab-pane label="最热" name="zr"><!--点赞数排序--></el-tab-pane>
                                <el-tab-pane label="默认" name="cts"></el-tab-pane>
                            </el-tabs>

                            <div class="woo-box-flex">
                              <div class="woo-avatar-main">
                                <img  @click="goUHome(lander.uid)"  class="fplfaceimg hander" :src="$store.state.faceimg" >
                              </div>
                              <div class="woo-box-item-flex">
                                <quill-editor  v-model="t.commentCont"   :options="pleditorOption"   :disabled="nouse|| !ihasReplay" class="fpledit"/>
                              </div>
                            </div>
                            <div class="Tool_check">
                                <el-button @click="subComment(t,i)" size="mini" round type="warning"   :disabled="nouse|| !ihasReplay">评论</el-button>
                            </div>
                            <div class="clear">

                                <div class="fbl_item" v-for="(tc,ic) in t.commentli" :key="ic">
                                    <img  @click="goUHome(tc.commentUid)"  class="fplfaceimg hander" :src="tc.faceimg" >
                                    <div class="fbl_contsall">

                                        <p class=" hh fbl_first" >
                                            <span class="fbl_uname hander" @click="goUHome(tc.commentUid)">{{tc.uname}}</span> <el-tag v-if="tc.istop=='1'" type="danger" size="mini">置顶</el-tag>

                                            <span  @click="deleteComment(t,i,tc,ic)" v-if="lander.uid== tc.commentUid " class="pull-right fbl_btnleftline hander" >&nbsp;<i class="el-icon-delete" />删除&nbsp;</span>
                                            <span   @click="editComment(t,i,tc,ic,1)" v-if="lander.uid== tc.commentUid  ||quanxian=='1'" class="pull-right fbl_btnleftline hander"  >&nbsp;<i class="el-icon-edit" />编辑&nbsp;</span>
                                            <span   @click="hitComment(t,i,tc,ic,1)" class="pull-right fbl_btnleftline hander"  >&nbsp;<i class="fa fa-thumbs-up" />{{tc.hitNum==0?'点赞':tc.hitNum}}&nbsp;</span>
                                            <span  @click="replayHandle(t,i,tc,ic,1)"  class="pull-right fbl_btnleftline hander">&nbsp;<i class="el-icon-chat-square" />回复&nbsp;</span>
                                            <span class="fbl_time">{{tc.cts}}</span>

                                        </p>

                                         <div class="hh  zxplcont margintop5" v-html="tc.cont"></div>




                                        <div v-if=" tc.hfli.length>0" class="wbpro-list">
                                            <div  class="fbl_item" v-for="(thf,ihf) in tc.hfli" :key="ihf">
                                                <!-- <img  @click="goUHome(thf.commentUid)" class="fplfaceimg hander" :src="thf.faceimg" > -->
                                                <div class="">

                                                    <p class="hh fbl_first" >
                                                        <span class="fbl_uname hander"  @click="replayHandle(t,i,tc,ic,2,thf,ihf)" >{{thf.uname}}</span>
                                                        <span class="fbl_hfwz"  >回复</span>
                                                        <span class="fbl_uname hander"  @click="replayHandle(t,i,tc,ic,3,thf,ihf)">{{thf.hfuname}}</span>
                                                        <el-tag v-if="thf.istop=='1'" type="danger" size="mini">置顶</el-tag>

                                                        <span   @click="deleteCommentReplay(t,i,tc,ic,thf,ihf)"  v-if="lander.uid== thf.commentUid " class="pull-right fbl_btnleftline hander" >&nbsp;<i class="el-icon-delete" />删除&nbsp;</span>
                                                        <span @click="editComment(t,i,tc,ic,2,thf,ihf)" v-if="lander.uid== thf.commentUid ||quanxian=='1' " class="pull-right fbl_btnleftline hander"  >&nbsp;<i class="el-icon-edit" />编辑&nbsp;</span>
                                                        <span  @click="hitComment(t,i,tc,ic,2,thf,ihf)" class="pull-right fbl_btnleftline hander"  >&nbsp;<i class="fa fa-thumbs-up" />{{thf.hitNum==0?'点赞':thf.hitNum}}&nbsp;</span>
                                                        <span   @click="replayHandle(t,i,tc,ic,2,thf,ihf)"   class="pull-right fbl_btnleftline hander">&nbsp;<i class="el-icon-chat-square" />回复&nbsp;</span>
                                                        <span class="fbl_time">{{thf.cts}}</span>

                                                    </p>
                                                    <div class="hh  zxplcont margintop5" v-html="thf.cont"></div>

                                                </div>
                                            </div>

                                        </div>
                                        <img src="../../../assets/img/reflashing.gif" v-if="tc.hfliLoading" class="suxianing">
                                        <el-divider v-if="tc.hfTotal-(tc.hfPageNum*tc.hfPageSize)>0" @click="seeReplayNextPage(t,i,tc,ic,thf,ihf)" class="hander">查看剩余{{tc.hfTotal-(tc.hfPageNum*tc.hfPageSize)}}条回复</el-divider>

                                    </div>
                                </div>


                            </div>
                        </div>
                        <!--pl-->
                        <div class="baiseback">
                            <div class="center" v-if="commentliLoading">
                                <img src="../../../assets/img/loading.gif">
                                <p class="typedesc">加载中</p>
                            </div>

                            <div class="center" v-if="!commentliLoading&&t.commentli.length==0">
                                <img src="../../../assets/img/zwsj.png" class="zwsjx">
                                <p class="typedesc">暂无评论</p>
                            </div>
                        </div>
                    </div>

                    <div class="baiseback">

                        <div class="center">
                            <el-pagination  v-if="webW"
                                    @current-change="handlePageChange"
                                    :current-page="query.pageNo"
                                    :page-size="query.pageSize"
                                    layout="total, prev, pager, next"
                                    :total="pageTotal">
                            </el-pagination>
                        </div>

                        <p class="typedesc center" v-if="commentDataFinish">没有评论了</p>
                    </div>

                    <div class="baiseback">
                    <Footer></Footer>
                    </div>



                </div>
                <div class="col-sm-3" v-if="webW" >
                    <div id="JfRightMenuOut">
                        <div  :class="(fixedRightmenu?'fixedMenuCls':'')" :style="fixedRightmenu?('width:'+RightMenuWidth+'px'):''" id="JfRightMenu">
                            <div class="baiseback" >
                                <div  class="center">

                                   <img @click="goUHome(author.id)" :src="author.faceimg" class="typeicon hander">
                                    <div class="h20"></div>
                                    <p @click="goUHome(author.id)" class="hander"><b>{{author.uname}}</b></p>
                                    <table class="typetj">
                                        <tr style="height:100px;">
                                            <td><el-button type="warning" round  @click="attHandle" >{{IattHe?'已关注':'关注'}}</el-button></td>
                                            <td>
<!--                                                <el-button type="warning" round @click="sixin">私信</el-button>-->
                                                <el-button type="success" round    @click="goUHome(author.id)">主页</el-button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><b>{{author.fansNum}}</b></td>
                                            <td><b>{{author.forumNum}}</b></td>
                                        </tr>
                                        <tr>
                                            <td><span  class="typedesc">粉丝数</span></td>
                                            <td><span  class="typedesc">帖子数</span></td>
                                        </tr>
                                    </table>
                                    <hr>

                                </div>

                                <p  class="biaoti"><span>最新主题</span></p>
                                 <p @click="godetailF(t)"  class="rebang hh hander"  v-for="(t,i) in lastForumList" :key="i"><span>&nbsp;</span>{{t.ftitle}}</p>
                                <div class="center" v-if="lastForumListLoading">
                                    <img src="../../../assets/img/loading.gif">
                                    <p class="typedesc">加载中</p>
                                </div>

                                <div class="center" v-if="!lastForumListLoading&&lastForumList.length==0">
                                    <img src="../../../assets/img/zwsj.png" class="zwsjx">
                                    <p class="typedesc">暂无数据</p>
                                </div>



                            </div>
                        </div>
                        <div v-if="fixedRightmenu" :style="'width:'+RightMenuWidth+'px'"><br></div>
                    </div>

                </div>

            </div>
            </div>
            <div class="h100"></div>
            <img src="../../../assets/img/fanhui.png" @click="goreaturn"   class="goreturn hander">
            <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">
        </div>


        <!-- 添加或者编辑弹出框 -->
        <el-dialog title="回复" :visible.sync="replayVisible"  :width="!webW?'90%':'50%'">
            <el-form  label-width="0"  >
                <p>请输入对'   {{replayUname}}  '的回复：</p>
                <quill-editor  v-model="replayCont"   :options="pleditorOption"   :disabled="nouse|| !ihasReplay"  />

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="replayVisible = false">取 消</el-button>
                    <el-button @click="saveReplay" type="primary"  :disabled="nouse|| !ihasReplay">回复</el-button>
                </span>
            </template>
        </el-dialog>


        <!--   评论 -->
        <el-dialog title="编辑评论或者回复" :visible.sync="editCommentVisible"  :width="!webW?'90%':'50%'">
            <el-form  label-width="0"  >
                <quill-editor  v-model="editCommentData.cont"   :options="pleditorOption"   :disabled="nouse|| !ihasReplay"  />

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editCommentVisible = false">取 消</el-button>
                    <el-button @click="editsaveComment" type="primary"  :disabled="nouse|| !ihasReplay">确定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 编辑帖子 -->
        <el-dialog title="编辑-主贴" :visible.sync="editForumVisible"  @close="colseBianji"  :fullscreen="webW?false:true">
            <el-form
                    label-width="0"
                    :model="dataForm"
                    :rules="dataFormRule"
                    ref="dataForm"
            >
                <el-form-item  prop="ftitle">
                    <el-input v-model="dataForm.ftitle"  placeholder="请输入标题" :disabled="nouse || !ihasRelease || !quanxian"></el-input>
                </el-form-item>



                <el-form-item>
                    <quill-editor ref="myQuillEditor" v-model="dataForm.fcontext"  :options="editorOption"   :disabled="nouse|| !ihasRelease || !quanxian" />
                    <img @click="uploadImgsHandleShow" src="../../../assets/img/upimg.png"
                         class="editor_upimg">
                    <img @click="uploadVideosHandleShow" src="../../../assets/img/upvideo.png"
                         class="editor_upvideo">
                </el-form-item>


                <div v-show="showUploadType==1">

                    <el-upload

                            ref="uploadImgs"
                            :auto-upload="true"
                            accept="image/*"
                            :limit="maximgnum"
                            multiple
                            :action=FILE_ACTION
                            :file-list="file_list_choose"
                            :list-type="webW?'picture-card':'picture'"
                            :on-exceed="handleExceed"
                            :on-success="handleFileSuccess"
                            :before-upload="beforeUpload"
                            :on-change="handleChangeUpload"
                            :on-remove="handleRemoveUpload"
                            :on-error="handleErrorUpload"
                    >
                        <i v-if="webW" class="el-icon-plus"></i>
                        <div v-else class="videoupcls"><i class="el-icon-plus icon"></i></div>
                    </el-upload>
                    <p v-if="update_imgs_numobj.all>0" style="margin-top: 20px;">
                        <el-alert
                                v-if="update_imgs_numobj.ing==0"
                                :title="'图片已成功上传' "
                                type="success"
                                show-icon>
                        </el-alert>
                        <el-alert
                                v-if="update_imgs_numobj.ing>0"
                                :title="'正在上传'+update_imgs_numobj.ing+'个图片  '"
                                description="图片上传中 请勿离开该页面..."
                                type="warning"
                                effect="dark"
                                show-icon>
                        </el-alert>
                        <el-alert
                                v-if="update_imgs_numobj.error>0"
                                :title="'上传失败'+update_imgs_numobj.error+'个图片 '"
                                type="error"
                                show-icon>
                        </el-alert>
                    </p>
                    <p class="tipc">提示：最多上传{{maximgnum}}张图片</p>

                </div>


                <div v-show="showUploadType==2">

                    <el-upload

                            ref="uploadVideos"
                            :auto-upload="true"
                            accept="video/*"
                            :limit="maxvideonum"
                            multiple
                            :action=FILE_ACTION2
                            :file-list="file_list_choose_video"
                             list-type="fileList"
                            :on-exceed="handleExceed2"
                            :on-success="handleFileSuccess2"
                            :before-upload="beforeUpload2"
                            :on-change="handleChangeUpload2"
                            :on-remove="handleRemoveUpload2"
                            :on-error="handleErrorUpload2"
                            :on-preview="handlePreviewUpload2"
                    >
                        <div class="videoupcls"><i class="el-icon-video-camera icon"></i></div>
                    </el-upload>
                    <p v-if="update_videos_numobj.all>0" style="margin-top: 20px;">
                        <el-alert
                                v-if="update_videos_numobj.ing==0"
                                :title="'视频已成功上传,请点击编辑按钮保存' "
                                type="success"
                                show-icon>
                        </el-alert>
                        <el-alert
                                v-if="update_videos_numobj.ing>0"
                                :title="'正在上传'+update_videos_numobj.ing+'个视频  '"
                                description="视频上传中请勿离开该页面..."
                                type="warning"
                                effect="dark"
                                show-icon>
                        </el-alert>
                        <el-alert
                                v-if="update_videos_numobj.error>0"
                                :title="'上传失败'+update_videos_numobj.error+'个图片 '"
                                type="error"
                                show-icon>
                        </el-alert>
                    </p>

                    <p class="tipc">提示：最多上传{{maxvideonum}}个视频，最大{{maxvideoarea}}M</p>

                </div>


                <el-form-item>
                    <el-checkbox @change="openVoteHandle" v-model="openVote"  :disabled="nouse || !ihasRelease || !quanxian">开启投票</el-checkbox>

                </el-form-item>
                <div v-if="openVote">

                    <el-form-item v-for="(t,i) in voteItemli" :key="i">
                        <el-row>
                            <el-col :span="webW?14:16">
                                <el-input v-model="t.vitem"  placeholder="请输入选项" ></el-input>
                            </el-col>
                            <el-col :span="webW?5:4">
                                <el-button  @click="saveItem(t,i)" type="warning" icon="el-icon-edit"  :disabled="nouse || !ihasRelease || !quanxian"  >{{webW?'保存选项':''}}</el-button>

                            </el-col>
                            <el-col :span="webW?5:4">
                                <el-button  @click="delItem(t,i)" type="danger" icon="el-icon-delete"  :disabled="nouse || !ihasRelease || !quanxian"  >{{webW?'删除选项':''}}</el-button>

                            </el-col>
                        </el-row>


                    </el-form-item>
                    <el-form-item >
                        <el-button @click="addItem" size="mini" type="primary" icon="el-icon-plus">添加选项</el-button>
                    </el-form-item>

                    <el-form-item >
                        选项类型： <el-radio v-model="dataForm.vtype" label="dx">单选</el-radio>
                        <el-radio v-model="dataForm.vtype" label="mx">多选</el-radio>
                    </el-form-item>

                    <el-form-item >
                        投票日期： <el-date-picker
                            :class="webW?'':'riqixzq'"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="dataForm.voteDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :disabled="nouse || !ihasRelease">
                    </el-date-picker>
                    </el-form-item>

                    <el-form-item >
                        <el-checkbox v-model="dataForm.vshowNumBoo"  :disabled="nouse || !ihasRelease || !quanxian">显示已投票数</el-checkbox>
                        <el-checkbox v-model="dataForm.vshowPeopleBoo"  :disabled="nouse || !ihasRelease || !quanxian">显示已投票用户</el-checkbox>
                    </el-form-item>
                </div>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editForumVisible = false">取 消</el-button>
                    <el-button @click="saveEditForumDetail" type="warning"   :disabled="nouse || !ihasRelease || (update_imgs_numobj.ing!=undefined&&update_imgs_numobj.ing>0) || (update_videos_numobj.ing!=undefined&&update_videos_numobj.ing>0) " >确定</el-button>
                </span>
            </template>
        </el-dialog>


        <!-- 查看投票用户 -->
        <el-dialog title="查看投票用户" :visible.sync="votePeopleVisible"    :width="!webW?'90%':'50%'">
            <div class="row" v-if="webW">
                <div class="col-sm-2 center" v-for="(t,i) in votePeopleData" :key="i">
                    <img  @click="goUHome(t.voteUid)"  :src="t.faceimg"   class="touxiangfantt hander" >
                    <p class="oneline hander"  @click="goUHome(t.voteUid)">{{t.uname }}</p>
                </div>
            </div>

            <el-row :gutter="20" v-if="!webW">
                <el-col :span="6"  v-for="(t,i) in votePeopleData" :key="i">
                    <div class="center">
                        <img :src="t.faceimg"  @click="goUHome(t.voteUid)"   class="touxiangfantt hander" >
                        <p class="oneline hander"  @click="goUHome(t.voteUid)">{{t.uname}}</p>
                    </div>
                </el-col>

            </el-row>


            <div class="baiseback"  v-if="votePeopleDataloading">
                <div class="center">
                    <img src="../../../assets/img/loading.gif">
                    <p class="typedesc">数据加载中....</p>
                </div>
            </div>
            <div class="baiseback" style="height: 100vh;"  v-if="!votePeopleDataloading&&votePeopleData.length==0">
                <div class="center">
                    <img src="../../../assets/img/zwsj.png">
                    <p class="typedesc">暂无数据</p>
                </div>
            </div>


            <div class="center" >
                <el-pagination v-if="webW"
                               @current-change="handleVotePeoplePageChange"
                               :current-page="votePeopleQuery.pageNo"
                               :page-size="votePeopleQuery.pageSize"
                               layout="total, prev, pager, next"
                               :total="votePeoplePageTotal">
                </el-pagination>


            </div>

            <p class="typedesc center" v-if="!webW" @click="getVotePeoplePage">{{votePeopleDataFinish?'没有数据了':'点击查看更多'}}</p>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="votePeopleVisible = false">取 消</el-button>
                </span>
            </template>
        </el-dialog>

        <el-dialog title="预览视频" :visible.sync="videoVisible" :append-to-body="true"
                   @close="closeYlVideodialog" :fullscreen="webW?false:true" :class="webW?'':'heiseplayertck'"  >
            <video :src="playVideo" id="ylvideo" controls style="width: 100%;"></video>

        </el-dialog>


    </div>


</template>
<script>
    import axios from 'axios'
    import {  quillEditor,Quill} from 'vue-quill-editor'
    import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import quillEmoji from 'quill-emoji'
    import 'quill-emoji/dist/quill-emoji.css'
    Quill.register('modules/ImageExtend', ImageExtend)
    Quill.register('modules/quillEmoji', quillEmoji)
    import '../../../api/image-paste.min.js';

    import {
        dealResult,
        getWindowWidth,
        messageSocketUrl,
        maxvideoarea,
        maxvideonum,
        maximgnum,
        forumImgGongge
    } from '../../../api/common'
    import {
        getForumDetail,
        forumpage,
        ishit,
        iscollect,
        releaseForum,
        commentpage,
        saveComment,
        delComment,
        getUserActionForIndex,
        hitcomment,
        isatt,
        atthe,
        delmyForum,
        getVotePeopleList,
        saveMyVote,
        getVoteItemList,
        saveVoteItem, delVoteItem,
        delForumMedia,saveFroumMedias,

    } from '../../../api';


    import Footer from "../Footer";
    import ForumLeft from "./ForumLeft";
    import PubSub from "pubsub-js";


    let  CON_ACTION=process.env.VUE_APP_API_ROOT+"/common/upimg?type=forum_detail";
    let vm=null;
    //vue修改CON_ACTION没用，所以用原始的js方法
    function GetQueryString(name)  {
        let s= window.location+"";
        let r =s.substr( s.indexOf("?")+1,s.length)
        let arr=r.split("&");
        for(let i=0;i<arr.length;i++){
            let arr2=arr[i].split("=");
            if(arr2[0]==name)return arr2[1];
        }
         return "";
    }

    export default {
        name: 'ForumDetail',
        components: {
            ForumLeft,
            quillEditor,
            Footer
        },

        data() {
            return {
                videoplayitemWidth:0,
                nowvideo:{},

                jiugonggeWidth:500,
                jiugonggeItemWidth:0,

                showUploadType: 0,
                FILE_ACTION: '',
                maximgnum: 0,
                file_list_choose: [],
                update_imgs_numobj:{all:0},


                FILE_ACTION2: '',
                maxvideonum: 0,
                maxvideoarea: 0,
                file_list_choose_video: [],
                update_videos_numobj:{all:0},
                videoVisible: false,
                playVideo: '',

                quanxian:'0',
                votePeopleVisible:false,
                votePeopleQuery:{
                    itemId:'',
                    pageNo:1,
                    pageSize:30,
                },
                votePeopleDataloading:true,
                votePeopleData:[],
                votePeopleDataFinish:false,
                votePeoplePageTotal:0,
                tv:{},

                openVote:false,
                voteItemli:[],


                activeName:'zr',

                needLoad:true,
                needLoadComment:true,

                webW:true,
                dataForm :{
                    id :'',
                    ftitle : '',
                    fcontext : '',
                },
                dataFormRule: {
                    ftitle: [{required: true, message: '不能为空', trigger: 'blur',min:1,max:100 }],

                },
                editForumVisible:false,

                IattHe:false,

                id:'',
                goPosition:'top',
                author:{},
                lastForumList:[],
                lastForumListLoading:true,

                commentliLoading:true,

                editCommentVisible:false,
                editCommentData:{},

                replayVisible:false,
                replayUname:'',
                replayCont:'',
                replayData:{},

                openAutoReflashComments:false,
                scrolltop:false,

                nouse:false,//禁用
                //菜单固定
                fixedLeftmenu:false,
                LeftMenuWidth:0,

                fixedRightmenu:false,
                RightMenuWidth:0,

                lander: {},
                //发帖
                dataForm :{
                    id :'',
                    ftitle : '',
                    fcontext : '',

                    vtype:'dx',
                    voteDate:'',
                    vshowNumBoo:false,
                    vshowPeopleBoo:false,
                },
                dataFormRule: {
                    ftitle: [{required: true, message: '不能为空', trigger: 'blur',min:1,max:100 }],

                },



                hasTypeInfo:false,
                ihasReplay:true,
                ihasRelease:true,

                //帖子信息
                tableData: [],
                tableDataloading:true,
                commentDataFinish:false,//避免滚动条在最后一直请求

                query: {
                    pageNo: 1,
                    pageSize: 30,
                    orderby:'zr',
                },
                pageTotal: 0,


                editorOption: {
                    modules: {
                        'emoji-toolbar': true,
                        'emoji-shortname': true,

                        /* 还有一些其他的模块*/
                        imagePaste: {
                            addImageBlob: function (blob, callback) {
                                var formData = new FormData()
                                formData.append('file', blob);

                                // your upload function, get the uploaded image url, add then
                                let config = {
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                        "Accept": "*/*",
                                        "uidh":JSON.parse(vm.$store.state.logininfo).uid,
                                        "tokenh":JSON.parse(vm.$store.state.logininfo).token,
                                        "forumId":vm.id
                                    }

                                }
                                // 上传接口
                                axios.post(CON_ACTION, formData, config).then(res => {

                                    let imgUrl = res.data.obj // 服务器返回的图片url
                                    callback(imgUrl)



                                })
                            }
                        },

                        ImageExtend: { // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
                            loading: true,//可选参数 是否显示上传进度和提示语
                            name: 'file', // 图片参数名
                            size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
                            action: CON_ACTION, // 服务器地址, 如果action为空，则采用base64插入图片
                            // response 为一个函数用来获取服务器返回的具体图片地址
                            // 例如服务器返回{code: 200; data:{ url: 'baidu.com'}}
                            // 则 return res.data.url
                            response: res => {
                                return res.obj;
                            },
                            headers: xhr => {
                            //上传图片请求需要携带token的 在xhr.setRequestHeader中设置
                                xhr.setRequestHeader(
                                    "uidh",
                                    JSON.parse(vm.$store.state.logininfo).uid
                                );
                                xhr.setRequestHeader(
                                    "tokenh",
                                    JSON.parse(vm.$store.state.logininfo).token
                                );
                                xhr.setRequestHeader(
                                    "forumId",
                                     vm.id
                                );
                            }, // 可选参数 设置请求头部
                            sizeError: () => {
                            }, // 图片超过大小的回调
                            start: () => {
                            }, // 可选参数 自定义开始上传触发事件
                            end: () => {
                            }, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
                            error: () => {
                            }, // 可选参数 上传失败触发的事件
                            success: () => {
                            }, // 可选参数  上传成功触发的事件
                            // change: (xhr, formData) => {
                            // xhr.setRequestHeader('myHeader','myValue')
                            // formData.append('token', 'myToken')
                            // } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
                        },
                        toolbar: {


                            container:  ['emoji'],//container,
                            handlers: {
                                'image': function () {
                                    QuillWatch.emit(this.quill.id)
                                }
                            }

                        }
                    },
                    //主题
                    theme: "snow",
                    placeholder: "请输入正文"

                },

                pleditorOption: {
                    modules: {
                        'emoji-toolbar': true,
                        'emoji-shortname': true,

                        toolbar: {
                            container:  [ 'emoji'],

                        }
                    },
                    //主题
                    theme: "snow",
                    placeholder: "请输入..."

                },

            };
        },
        methods: {


            playvideo2(t,i,vt,vindex){
                this.getVideoplayitemWidth();
                this.playvideo(t,i,vt,vindex);

            },

            playvideo(t,i,vt,vindex){
                this.stopvideo();

                if(vt.vurl.indexOf('/temp')>-1){
                    this.$notify({
                        title: '系统提示',
                        message: '当前播放的是临时视频可能卡顿，请稍后刷新页面重试' ,
                        duration:20000
                    });
                }

                vt.vindex=vindex;
                vt.isshow=1;
                vt.index=i;
                vt.t=t;
                this.tableData[i].nowvideo=vt;
                this.tableData[i].videosli[vindex].isplay='1';

                this.$message.info('视频加载中...');

                let v=document.getElementById('videoitem_'+t.id);
                if(v!=undefined){
                    setTimeout(()=>{
                        v.play();
                    },2000)
                }


                this.nowvideo=vt;
            },
            stopvideo(){
                if(this.nowvideo.index!=undefined&&this.nowvideo.vindex!=undefined){

                    let v=document.getElementById('videoitem_'+this.nowvideo.t.id);
                    if(v!=undefined){
                        this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='0';
                        setTimeout(()=>{
                            v.pause();
                        },200);
                    }

                }


            },
            jiantingVideo(e){
                let id=e.target.id.split('_')[1];
                let index=e.target.dataset.index;
                let vindex=e.target.dataset.vindex;
                let currentTime=e.target.currentTime;
                let duration=e.target.duration;
                if(this.nowvideo.t==undefined){
                    return;
                }
                if(id==this.nowvideo.t.id){

                    //本视频播放
                    if(e.target.paused){
                        if(this.nowvideo.isplay!='0')this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='0';
                    }else{
                        if(this.nowvideo.isplay!='1'){
                            this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='1';
                        }
                    }
                }else{
                    //切换视频播放

                    if(!e.target.paused){
                        let nowvideo={
                            t:this.tableData[index],
                            index:index,
                            vindex:vindex,
                            vurl:this.tableData[index].videosli[vindex].vurl,
                            isplay:this.tableData[index].videosli[vindex].isplay,
                            isshow:'1'
                        }


                        let v=document.getElementById('videoitem_'+this.nowvideo.t.id);
                        if(v!=undefined){
                            this.tableData[index].videosli[vindex].isplay='1';
                            this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='0';
                            setTimeout(()=>{
                                v.pause();
                            },200);
                        }

                        setTimeout(()=>{
                            this.nowvideo=nowvideo;
                        },1000)
                    }

                }


                if(currentTime>=duration){
                    if(this.nowvideo.t.videosli.length>1&&this.nowvideo.vindex+1<this.nowvideo.t.videosli.length){
                        let next_vindex=parseInt(vindex)+1;
                        //自动播放下一个视频

                        this.playvideo(this.nowvideo.t,this.nowvideo.index ,this.nowvideo.t.videosli[next_vindex],next_vindex);
                    }
                }


            },

            uploadImgsHandleShow() {
                if (this.nouse) this.$message.info('你已被禁言');
                else if(!this.ihasRelease)this.$message.info('你没有发帖权限');
                else {
                    if (this.showUploadType != 1) this.showUploadType = 1;
                    else this.showUploadType = 0;
                }
            },
            uploadVideosHandleShow() {
                if (this.nouse) this.$message.info('你已被禁言');
                else if(!this.ihasRelease)this.$message.info('你没有发帖权限');
                else {
                    if (this.showUploadType != 2) this.showUploadType = 2;
                    else this.showUploadType = 0;
                }
            },
            handleExceed() {
                if (this.file_list_choose.length < this.maximgnum) {
                    this.$message.error('最多上传' + this.maximgnum + "张图片");
                    return false;
                }
            },
            handleErrorUpload(err, file, fileList) {
                console.log(err)
                this.getUploadImgNum();
                if(this.update_imgs_numobj.error==undefined)this.update_imgs_numobj.error=1;
                else this.update_imgs_numobj.error++;
            },
            handleFileSuccess(res, file) {


                dealResult(res);
                if (res.status == 1) {
                    this.$message.success('上传成功');

                    for (let i = 0; i < this.file_list_choose.length; i++) {
                        if (file.url == this.file_list_choose[i].url) {
                            this.file_list_choose[i].url = res.obj;

                        }
                    }


                        this.saveFroumMediasFunc("img" );




                } else {
                    this.$message.error('上传失败');
                }
                this.getUploadImgNum();

            },
            beforeUpload() {

            },
            handleChangeUpload(file, fileList) {

                this.file_list_choose = fileList;
                this.getUploadImgNum();
            },
            handleRemoveUpload(file, fileList) {
                this.delForumMediaFunc(file,fileList,'img');


            },
            getUploadImgNum(){
                let all=this.file_list_choose.length;
                let succ=0;
                let ing=0;
                for (let i = 0; i < this.file_list_choose.length; i++) {
                    if ( this.file_list_choose[i].url!=undefined &&  this.file_list_choose[i].url.indexOf('upimg')>-1) {
                        succ++;
                    }else {
                        ing++;
                    }
                }
                this.update_imgs_numobj={succ:succ,ing:ing,all:all}
            },


            handleExceed2() {
                if (this.file_list_choose_video.length < this.maxvideonum) {
                    this.$message.error('最多上传' + this.maxvideonum + "个视频");
                    return false;
                }
            },
            handleErrorUpload2(err, file, fileList) {
                console.log(err);
                this.getUploadVideoNum();
                if(this.update_videos_numobj.error==undefined)this.update_videos_numobj.error=1;
                else this.update_videos_numobj.error++;
            },

            handleFileSuccess2(res, file) {
                dealResult(res);
                if (res.status == 1) {
                    this.$message.success('上传成功');

                    for (let i = 0; i < this.file_list_choose_video.length; i++) {
                        if (file.url == this.file_list_choose_video[i].url) {
                            this.file_list_choose_video[i].url = res.obj;
                        }
                    }

                        this.saveFroumMediasFunc("video" );


                } else {
                    this.$message.error('上传失败');
                }
                this.getUploadVideoNum();


            },
            beforeUpload2(file) {

                const isLt2M = file.size / 1024 / 1024 <= this.maxvideoarea;


                if (!isLt2M) {
                    this.$message.error('视频大小不能超过 ' + this.maxvideoarea + 'MB!');
                }
                return isLt2M;
            },
            handleChangeUpload2(file, fileList) {

                this.file_list_choose_video = fileList;
                this.getUploadVideoNum();
            },
            handleRemoveUpload2(file, fileList) {
                 this.delForumMediaFunc(file,fileList,'video');

            },
            delForumMediaFunc(file,fileList,mtype){
                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id:this.id,
                    url:file.url,
                    mtype:mtype
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "删除中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                delForumMedia( o).then((res) => {
                    this.loading.close();

                    dealResult(res.data);

                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg)
                       if(mtype=='img') {
                           this.file_list_choose = fileList;
                           this.getUploadImgNum();
                       }
                       if(mtype=='video') {
                           this.file_list_choose_video  = fileList;
                           this.getUploadVideoNum();
                       }



                    } else{
                        this.$message.error(res.data.msg)
                    }

                })
            },
            saveFroumMediasFunc(mtype){
                let urls="";
                if(mtype=='img'){
                    for(let i=0;i<this.file_list_choose.length;i++){
                        urls+=this.file_list_choose[i].url+","
                    }
                }
                if(mtype=='video'){
                    for(let i=0;i<this.file_list_choose_video.length;i++){
                        urls+=this.file_list_choose_video[i].url+","
                    }
                }
                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id:this.id,
                    urls:urls,
                    mtype:mtype
                }
                setTimeout(()=>{
                    saveFroumMedias( o).then((res) => {

                        dealResult(res.data);
                        if (res.data.status == 1) {

                        } else{
                            this.$message.error(res.data.msg)
                        }
                    })
                },500)

            },
            handlePreviewUpload2(file) {
                this.playVideo = file.url;

                setTimeout(() => {
                    let ylvideo = document.getElementById('ylvideo');
                    ylvideo.play();
                }, 2000);
                this.videoVisible = true;

            },
            getUploadVideoNum(){
                let all=this.file_list_choose_video.length;
                let succ=0;
                let ing=0;
                for (let i = 0; i < this.file_list_choose_video.length; i++) {
                    if ( this.file_list_choose_video[i].url!=undefined &&  this.file_list_choose_video[i].url.indexOf('upimg')>-1) {
                        succ++;
                    }else {
                        ing++;
                    }
                }
                this.update_videos_numobj={succ:succ,ing:ing,all:all}
            },

            closeYlVideodialog() {
                let ylvideo = document.getElementById('ylvideo');

                setTimeout(() => {
                    ylvideo.pause();
                }, 200)

            },

            openVoteHandle(){
                if(this.openVote){
                    this.voteItemli=[];
                    this.dataForm.voteDate='';
                    this.dataForm.vshowNumBoo=false;
                    this.dataForm.vshowPeopleBoo=false;
                    this.dataForm.vtype="dx";
                    this.getVoteItemList(0,this.tableData[0]);

                }
            },
            delItem(t,index){

                this.$confirm("确定删除  ？ "+(t.peopleNum>0?"（已有人参与该项投票了哦）":"")+"系统将重新计算投票结果，删除后将不可恢复哦", "提示", {
                    type: "warning",
                    customClass: 'msgboxgf'
                }) .then(() => {
                    this.loading = this.$loading({
                        lock: true,
                        text: "请求中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    let o={ id:t.id,uid:this.lander.uid,token:this.lander.token}
                    delVoteItem( o).then((res) => {
                        this.loading.close();
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success(res.data.msg)
                            this.voteItemli.splice(index,1);
                            this.getVoteItemList(0,this.tableData[0]);
                        } else{
                            this.$message.error(res.data.msg)
                        }
                    })
                });

            },
            addItem(){
                this.$prompt('请输入选项', '输入框', {
                    confirmButtonText: '确定添加',
                    cancelButtonText: '取消',
                    customClass: 'msgboxgf'
                }).then(({ value }) => {

                    let o = { vitem:value  };
                    this.saveVoteItemFunc(o );

                });
            },
            saveItem(t,index){
                let o = { vitem:t.vitem,id:t.id  };
                this.saveVoteItemFunc(o );
            },
            saveVoteItemFunc(o ){

                if(o.vitem==''){
                    this.$message.info("选项不可为空");return;
                }
                if(o.vitem.length>250){
                    this.$message.info("选项字数不可超过250");return;
                }
                o.uid=this.lander.uid;
                o.token=this.lander.token;
                o.forumId=this.id;
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                saveVoteItem(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success('操作成功')


                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },


            handleVotePeoplePageChange(val) {
                this.votePeopleQuery.pageNo = val;
                this.votePeopleData=[];
                this.getVotePeoplePage();

                this.votePeopleDataFinish=false;


            },


            getVotePeoplePage() {
                this.votePeopleDataloading=true;
                this.votePeopleDataFinish=false;

                this.votePeopleQuery.uid = this.lander.uid;
                this.votePeopleQuery.token = this.lander.token;
                this.votePeopleQuery.itemId =  this.tv.id;

                getVotePeopleList( this.votePeopleQuery).then((res) => {
                    this.votePeopleDataloading=false;
                    dealResult(res.data);


                    if (res.data.status == 1) {


                        let li= res.data.obj.list;
                        if(li.length==0){

                            this.votePeopleDataFinish=true;

                            return ;
                        }



                        if(this.webW) this.votePeopleData= li ;
                        else this.votePeopleData=this.votePeopleData.concat(li);
                        this.votePeoplePageTotal = res.data.obj.total//该页总共多少条记录

                        if( !this.webW  ) {
                            if( res.data.obj.hasNextPage )this.votePeopleQuery.pageNo=res.data.obj.nextPage;
                            else this.votePeopleQuery.pageNo=this.votePeopleQuery.pageNo+1;
                        }

                    }else {
                        this.votePeopleDataFinish=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            seeVotePeople(tv){
                this.votePeopleVisible=true;
                this.tv=tv;

                this.votePeopleQuery.pageNo = 1;
                this.votePeopleData=[];
                this.votePeopleDataFinish=false;
                this.getVotePeoplePage();


            },
            saveMyVoteFunc(t,index,o){


                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                saveMyVote(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1 || res.data.status == 11) {
                        this.tableData[0].ivote='1';
                        this.getVoteItemList(0,t);
                        this.$message.success(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            mxVoteHandle(t,index ){

                if(t.myvoteMx.length==0){
                    this.$message.info("至少选择一项");return;
                }

                let itemids="";
                for(let i=0;i<t.myvoteMx.length;i++){
                    itemids+=t.myvoteMx[i]+",";
                }
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    itemIds:itemids,
                    forumId:t.id,
                };
                this.saveMyVoteFunc(t,index ,o);

            },
            dxVoteHandle(t,index,tv,indexv){
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    itemIds:tv.id,
                    forumId:t.id,
                };
                this.saveMyVoteFunc(t,index,o);
            },
            getVotePeopleList(index,t,indexv,tv){
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    itemId:tv.id,
                };
                getVotePeopleList(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1 ) {
                       this.tableData[0].voteItemli[indexv].votePeopleli=res.data.obj.list ;
                        this.$forceUpdate();

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getVoteItemList(index,t){
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:this.id,
                };
                getVoteItemList(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        let li=res.data.obj.voteItemList;
                        this.voteItemli=li;
                        for(let i=0;i<li.length;i++){
                            li[i].votePeopleli=[];
                        }
                        this.tableData[index].voteItemli=li;
                        this.tableData[index].ivote=res.data.obj.ivote;


                        for(let i=0;i<li.length;i++){
                            if(li[i].peopleNum>0  ) {
                                this.getVotePeopleList(0,t,i,li[i]);
                            }
                        }
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },

            goUHome(uid){
                this.$router.push('Home?type=myforum&authorId='+uid);
            },
            tabClick(tab, event) {
                this.query.orderby=this.activeName;
                this.query.pageNo=1;
                this.tableData[0].commentli=[];
                this.commentDataFinish=false;
                this.getCommentPage(this.tableData[0],0);
            },
            delForumHandel(){

                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    id:this.tableData[0].id
                }

                // 二次确认
                this.$confirm("确定删除主贴么？", "提示", {
                    type: "warning",
                    customClass: 'msgboxgf'
                }) .then(() => {
                    this.loading = this.$loading({
                        lock: true,
                        text: "删除中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    delmyForum(o).then((res) => {
                        this.loading.close();
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success(res.data.msg)
                            this.tableData=[];
                            this.$router.go(-1);

                            PubSub.publish('delFormListIndex',o.id);

                        }else{
                            this.$message.error(res.data.msg)
                        }

                    })
                });

            },
            editForumHandel(){
                this.needLoadComment=true;

                this.dataForm.ftitle=this.tableData[0].ftitle;
                this.dataForm.fcontext=this.tableData[0].fcontext;
                this.dataForm.id=this.tableData[0].id;

                this.dataForm.isVote=this.tableData[0].isVote;
                if(this.dataForm.isVote=='0')this.openVote=false;
                if(this.dataForm.isVote=='1')this.openVote=true;

                this.dataForm.vtype=this.tableData[0].vtype;

                this.dataForm.vstartTs=this.tableData[0].vstartTs;
                this.dataForm.vendTs=this.tableData[0].vendTs;

                let voteDate=[];
                voteDate.push(this.tableData[0].vstartTs);
                voteDate.push(this.tableData[0].vendTs);
                this.dataForm.voteDate=voteDate;

                this.dataForm.vshowNum=this.tableData[0].vshowNum;
                if(this.dataForm.vshowNum=='1')    this.dataForm.vshowNumBoo=true;
                if(this.dataForm.vshowNum=='0')    this.dataForm.vshowNumBoo=false;


                this.dataForm.vshowPeople=this.tableData[0].vshowPeople;
                if(this.dataForm.vshowPeople=='1')    this.dataForm.vshowPeopleBoo=true;
                if(this.dataForm.vshowPeople=='0')    this.dataForm.vshowPeopleBoo=false;




                this.editForumVisible=true;
            },
            //保存操作
            saveEditForumDetail() {
                //去除<p>标签
                this.dataForm.fcontext = this.dataForm.fcontext.replace(/<p><br><\/p>/g, '<br />').replace(/<p>([^<]*?)<\/p>/gi, '$1<br/>').replace(/<br>$/,"");
                //
                
                this.needLoadComment=true;


                this.$refs.dataForm.validate(valid => {
                    if (this.$refs.myQuillEditor.value == ''||this.dataForm.fcontext.trim().length==0) {
                        this.$message.error('请输入正文');
                        return  ;
                    }

                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;



                    } else {
                        if(this.openVote)this.dataForm.isVote="1";
                        else this.dataForm.isVote="0";

                        if(this.openVote){
                            if(this.voteItemli.length<2){
                                this.$message.info("至少2个投票选项");return;
                            }
                            for(let i=0;i<this.voteItemli.length;i++){
                                if(this.voteItemli[i].id==undefined||this.voteItemli[i].id==''){
                                    if(this.voteItemli[i].vitem==''){
                                        this.$message.info("请输入第"+(i+1)+"投票选项");return;
                                    }
                                }
                            }

                            if(this.dataForm.voteDate.length<2){
                                this.$message.info("请选择投票日期");return;
                            }
                            this.dataForm.vstartTs=this.dataForm.voteDate[0];
                            this.dataForm.vendTs=this.dataForm.voteDate[1];

                            this.dataForm.vshowNum='0';
                            if(this.dataForm.vshowNumBoo)this.dataForm.vshowNum='1';

                            this.dataForm.vshowPeople='0';
                            if(this.dataForm.vshowPeopleBoo)this.dataForm.vshowPeople='1';

                        }



                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;

                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });


                        releaseForum(this.dataForm).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg)
                                this.editForumVisible=false;



                                let atli=res.data.obj.atli;
                                if(atli!=null&&atli.length>0){
                                    for(let i=0;i<atli.length;i++){
                                        let mess2={name:this.lander.uid+"",receiver:atli[i]+"",msg:this.lander.uname+"  在帖子里 @ 了你"}
                                        this.sendMessage(JSON.stringify(mess2))
                                    }
                                }

                                this.update_imgs_numobj={all:0};
                                this.update_videos_numobj={all:0};




                                PubSub.publish('editFormListIndex',this.dataForm.id);
                            }else{
                                this.$message.error(res.data.msg)
                            }

                        })
                    }
                })
            },

            seeReplayNextPage(t,index,tc,indexc,thf,indexf){
                this.tableData[index].commentli[indexc].hfPageNum=tc.hfPageNum+1;
                this.tableData[index].commentli[indexc].hfliLoading=true;
                this.getCommentPageReplay(t,index,tc,indexc);
            },
            goreaturn(){
                this.$router.go(-1);
            },
            goshuaxin(){
                this.$message.info('正在刷新中...') ;
                this.getForumDetailFunc();
            },
            hitComment(t,index,tc,indexc,type,thf,indexf){
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    commentId:tc.id,
                };
                if(type==2)o.commentId=thf.id;
                hitcomment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1 || res.data.status == 11) {
                        if (res.data.status == 1 )  this.$message.success(res.data.msg)
                        if (res.data.status == 11 )  this.$message.info(res.data.msg)

                        if( type==1)this.tableData[index].commentli[indexc].hitNum=res.data.obj;
                        if( type==2)this.tableData[index].commentli[indexc].hfli[indexf].hitNum=res.data.obj;

                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" "+(res.data.status == 11?'取消了':'')+"点赞你的评论"}
                        this.sendMessage(JSON.stringify(mess))



                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })

            },
            editComment(t, index, tc, indexc, type, thf, indexf) {

                this.editCommentVisible = true;

                this.editCommentData.index = index;
                this.editCommentData.type = type;
                this.editCommentData.indexc = indexc;

                if(type==2){
                    this.editCommentData.id = thf.id;
                    this.editCommentData.cont = thf.cont;
                    this.editCommentData.indexf = indexf;
                }else{
                    this.editCommentData.id = tc.id;
                    this.editCommentData.cont = tc.cont;


                }


            },
            editsaveComment() {
                //去除<p>标签，过滤样式
                this.editCommentData.cont = this.editCommentData.cont.replace(/<([a-zA-Z1-6]+)(\s*[^>]*)?>/g, "<$1>").replace(/<p><br><\/p>/g, '<br />').replace(/<p>([^<]*?)<\/p>/gi, '$1<br/>');
                //
                let c = this.editCommentData.cont;
                if (c == undefined || c.trim().length == 0) {
                    this.$message.error('请输入评论内容');
                    return;
                }
                if (c.trim().length > 2000000) {
                    this.$message.error('评论内容200字以内');
                    return;
                }

                this.loading = this.$loading({
                    lock: true,
                    text: "保存中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: this.editCommentData.id,
                    cont: c,
                }
                saveComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.editCommentVisible = false;
                        if (this.editCommentData.type == 1) this.tableData[0].commentli[this.editCommentData.indexc].cont = c;

                        if (this.editCommentData.type == 2) this.tableData[0].commentli[this.editCommentData.indexc].hfli[this.editCommentData.indexf].cont = c;


                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            replayHandle(t,index,tc,ic,type,thf,ihf){
                if(type==1)this.replayUname=tc.uname;
                if(type==2)this.replayUname=thf.uname;
                if(type==3)this.replayUname=thf.hfuname;
                this.replayVisible=true;
                this.replayData=tc;
                this.replayData.index=index;
                this.replayData.indexc=ic;
                this.replayData.type=type;
                this.replayData.thf=thf;
                this.replayData.ihf=ihf;

                this.replayCont='';
            },

            saveReplay(){
                let c=this.replayCont;
                if ( c==undefined ||c.trim().length==0) {
                    this.$message.error('请输入评论内容');
                    return  ;
                }
                if (  c.trim().length>200000) {
                    this.$message.error('评论内容200字以内');
                    return  ;
                }
                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:this.replayData.forumId,
                    cont:c,
                    typeId:this.replayData.typeId,
                    hfId:this.replayData.id,
                    hfUid:this.replayData.commentUid,
                    ctype:this.tableData[0].ftype,
                }
                if(this.replayData.type==2){
                    o.hfUid=this.replayData.thf.commentUid;
                }
                if(this.replayData.type==3){
                    o.hfUid=this.replayData.thf.hfUid;
                }

                this.loading = this.$loading({
                    lock: true,
                    text: "保存中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                saveComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.replayVisible=false;
                        this.tableData[this.replayData.index].commentNum=res.data.obj.commentNum;

                        this.tableData[this.replayData.index].commentli[this.replayData.indexc].hfli.splice(this.replayData.ihf+1,0,res.data.obj.commentobj);
                        this.tableData[this.replayData.index].commentli[this.replayData.indexc].replayNum=res.data.obj.commentobj.replayNum;

                        let mess={name:this.lander.uid+"",receiver:o.hfUid+"",msg:this.lander.uname+" "+ "回复了你"}
                        this.sendMessage(JSON.stringify(mess))

                        let atli=res.data.obj.atli;
                        if(atli!=null&&atli.length>0){
                            for(let i=0;i<atli.length;i++){
                                let mess2={name:this.lander.uid+"",receiver:atli[i]+"",msg:this.lander.uname+" "+ "在评论里 @ 了你"}
                                this.sendMessage(JSON.stringify(mess2))
                            }
                        }

                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })

            },
            subComment(t,index){
                let c=t.commentCont;
                if ( c==undefined ||c.trim().length==0) {
                    this.$message.error('请输入评论内容');
                    return  ;
                }
                if (  c.trim().length>2000000) {
                    this.$message.error('评论内容200字以内');
                    return  ;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "保存中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:t.id,
                    cont:c,
                    typeId:t.typeId,
                    ctype:this.tableData[0].ftype
                }
                saveComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData[index].commentCont='';
                        this.tableData[index].commentNum=res.data.obj.commentNum;
                        let obj=res.data.obj.commentobj;
                         obj.hfliLoading=false;
                         obj.hfli=[];
                        this.tableData[index].commentli.unshift( obj);



                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" "+ "评论你的帖子"}
                        this.sendMessage(JSON.stringify(mess))


                        let atli=res.data.obj.atli;
                        if(atli!=null&&atli.length>0){
                            for(let i=0;i<atli.length;i++){
                                let mess2={name:this.lander.uid+"",receiver:atli[i]+"",msg:this.lander.uname+" "+ "在评论里@了你"}
                                this.sendMessage(JSON.stringify(mess2))
                            }
                        }


                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })


            },

            deleteCommentReplay(t,index,tc,indexc,thf,indexhf){

                this.loading = this.$loading({
                    lock: true,
                    text: "删除中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id:thf.id,
                }
                delComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg);

                        this.tableData[index].commentli[indexc].hfli.splice(indexhf,1);

                        this.tableData[index].commentNum=res.data.obj;

                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })


            },
            deleteComment(t,index,tc,indexc){

                this.loading = this.$loading({
                    lock: true,
                    text: "删除中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id:tc.id,
                }
                delComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg);
                        this.tableData[index].commentli.splice(indexc,1);
                        this.tableData[index].commentNum=res.data.obj;

                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" 删除了评论"}
                        this.sendMessage(JSON.stringify(mess))

                    }  else {
                        this.$message.error(res.data.msg)
                    }
                })


            },

            getCommentPage(t,index){
                this.commentliLoading=true;
                this.commentDataFinish=false;

                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:t.id,
                    hfId:0,
                    pageNo:this.query.pageNo,
                    pageSize:this.query.pageSize,
                    orderby:this.query.orderby,
                }

                commentpage(o).then((res) => {
                    this.commentliLoading=false;
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let cli=res.data.obj.list;
                        if(cli.length==0){

                            this.commentDataFinish=true;

                            return ;
                        }


                        for(let i=0;i<cli.length;i++){
                            cli[i].hfli=[];
                            cli[i].hfliLoading=true;
                            cli[i].hfTotal=0;
                            cli[i].hfPageNum=1;
                            cli[i].hfPageSize=10;
                            if(cli[i].replayNum>0){
                                let indexc=this.tableData[index].commentli.length+i;

                                this.getCommentPageReplay(t,index,cli[i], indexc);

                            }
                            else{
                                cli[i].hfliLoading=false;
                            }
                        }

                        this.tableData[index].commentli=this.tableData[index].commentli.concat(cli);
                        this.pageTotal=res.data.obj.total;


                        if( this.openAutoReflashComments  ) {
                            if( res.data.obj.hasNextPage )this.query.pageNo=res.data.obj.nextPage;
                            else this.query.pageNo=this.query.pageNo+1;
                        }

                        this.fixedmenu();
                    }  else {
                        this.commentDataFinish=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getCommentPageReplay(t,index,tc,indexc){



                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    hfId:tc.id,
                    forumId:this.id,
                    pageNo: tc.hfPageNum,
                    pageSize: tc.hfPageSize,
                }

                commentpage(o).then((res) => {

                    this.tableData[index].commentli[indexc].hfliLoading=false;

                    if (res.data.status == 1) {
                        this.tableData[index].commentli[indexc].hfli=this.tableData[index].commentli[indexc].hfli.concat(res.data.obj.list);
                        this.tableData[index].commentli[indexc].hfTotal=res.data.obj.total;

                        this.$forceUpdate();

                    }
                })
            },

            collectHandle(t,index){
                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:t.id
                }
                iscollect(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData[index].iscollect="1";
                        this.tableData[index].collectNum=res.data.obj;
                        this.$message.success(res.data.msg)
                    }else if (res.data.status == 11){
                        this.tableData[index].iscollect="0";
                        this.tableData[index].collectNum=res.data.obj;
                        this.$message.info(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            hitHandle(t,index){
                let o={
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:t.id
                }
                ishit(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData[index].ishit="1";
                        this.tableData[index].hitNum=res.data.obj;
                        this.$message.success(res.data.msg)
                    }else if (res.data.status == 11){
                        this.tableData[index].ishit="0";
                        this.tableData[index].hitNum=res.data.obj;
                        this.$message.info(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    if (res.data.status == 1||res.data.status == 11) {

                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" "+(res.data.status == 11?'取消了':'')+"点赞你的帖子"}
                        this.sendMessage(JSON.stringify(mess))

                    }

                })
            },
            openAutoReflashCommentsFunc(){
                if(this.openAutoReflashComments)this.commentDataFinish=false;
            },
            gotopFunc(){
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },
            // 分页导航
            handlePageChange(val) {
                this.tableData[0].commentli=[];
                this.query.pageNo = val;
                this.getCommentPage(this.tableData[0],0);
                let commentMain=document.getElementById('commentMain');
                let top=commentMain.offsetTop;
                document.documentElement.scrollTop=top;
                 document.body.scrollTop=top;

            },




            godetailF(t){
                this.id=t.id;
                this.needLoad=false;
                this.needLoadComment=true;
                document.documentElement.scrollTop=0;
                document.body.scrollTop=0;
                this.goPosition='top';
                this.getForumDetailFunc();


            },
            getForumDetailFunc() {
               this.tableData=[];
                this.tableDataloading=true;
                    getForumDetail({uid: this.lander.uid, token: this.lander.token,id:this.id}).then((res) => {
                        dealResult(res.data);
                        this.tableDataloading=false;
                        if (res.data.status == 1) {
                            let type=res.data.obj.typeobj;
                            this.author=res.data.obj.authorobj;
                            this.quanxian=res.data.obj.quanxian;


                           if(this.needLoad){
                               this.getForumPage();
                               this.isattFunc(res.data.obj.forumobj.authorUid)
                           }

                            this.ihasRelease=true;
                            if(type.ihasRelease=='0'){
                                this.ihasRelease=false;
                               // setTimeout(()=>{this.$message.error("你没有发帖权限")},2000)
                            }
                            this.ihasReplay=true;
                            if(type.ihasReplay=='0'){
                                this.ihasReplay=false;
                                setTimeout(()=>{this.$message.error("你没有评论权限")},4000)
                            }




                             let li=[];
                             li.push(res.data.obj.forumobj);
                            li[0].commentli=[];
                            li[0].iscollect="0";
                            li[0].ishit="0";

                            li[0].voteItemli=[];
                            li[0].ivote='0';
                            li[0].myvoteDx='';
                            li[0].myvoteMx=[];
                            li[0].nowvideo={vindex:0,isshow:'0'};


                            let imgsli=res.data.obj.forumobj.imgsli;
                            this.file_list_choose=[];
                            if( imgsli!=null){
                                for(let i=0;i<imgsli.length;i++){
                                    this.file_list_choose.push({name:imgsli[i],url:imgsli[i]});
                                }
                                if(this.file_list_choose.length>0){
                                    this.showUploadType=1;
                                }

                            }

                            let videosli=res.data.obj.forumobj.videosli;
                            this.file_list_choose_video=[];
                            if( videosli!=null){
                                for(let i=0;i<videosli.length;i++){
                                    this.file_list_choose_video.push({name:videosli[i].vurl,url:videosli[i].vurl});
                                }
                                if(this.file_list_choose_video.length>0){
                                    this.showUploadType=2;

                                }

                            }



                            this.tableData=li;

                            this.pageTotal=0;


                            this.query.pageNo=1;
                            this.commentDataFinish=false;
                            if(this.needLoadComment)this.getCommentPage( this.tableData[0],0);
                            this.fixedmenu();


                                if(this.goPosition=='comment'){
                                    setTimeout(()=>{
                                        let commentMain=document.getElementById('commentMain');
                                        let top=commentMain.offsetTop;
                                        document.documentElement.scrollTop=top;
                                        document.body.scrollTop=top;
                                    },1000)
                                }



                            if(this.needLoadComment) this.getUserActionForIndexFunc(li);

                            this.getVoteItemList(0,this.tableData[0]);

                            if(sessionStorage.managerEditForumFromIndex=="1"){
                                //列表页的编辑按钮
                                this.editForumHandel();
                                sessionStorage.removeItem("managerEditForumFromIndex");
                            }

                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })


            },

            //展示用户是否点赞和评论
            getUserActionForIndexFunc(li) {
                let forumIds='';
                for(let i=0;i<li.length;i++){
                    forumIds+=li[i].id+",";
                }
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.forumIds=forumIds;

                getUserActionForIndex( this.query).then((res) => {

                    if (res.data.status == 1) {
                        let li2= res.data.obj;
                        for(let i=0;i<li2.length;i++){
                            let index=( this.tableData || []).findIndex((item) => item.id === li2[i].id);
                            this.tableData[index].iscollect=li2[i].iscollect;
                            this.tableData[index].ishit=li2[i].ishit;
                        }

                    }
                })
            },
            //关注按钮
            attHandle(){
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                let o={ tuid:this.author.id,uid:this.lander.uid,token:this.lander.token}
                atthe( o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.IattHe= true;
                        this.author.fansNum=res.data.obj;
                    }else   if (res.data.status == 11) {
                        this.IattHe= false;
                        this.author.fansNum=res.data.obj;
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //是否关注了他
            isattFunc(authorUid){
                 let o={ tuid:authorUid,uid:this.lander.uid,token:this.lander.token}
                isatt( o).then((res) => {

                    dealResult(res.data);

                    if (res.data.status == 1) {
                        this.IattHe= true;
                    }else   if (res.data.status == 11) {
                        this.IattHe= false;
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //获取帖子分页
            getForumPage( ) {
                this.lastForumListLoading=true;
                this.lastForumList=[];
                let o={pageNo:1,pageSize:30,authorUid:this.author.id,uid:this.lander.uid,token:this.lander.token}
                forumpage( o).then((res) => {
                    this.lastForumListLoading=false;
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.lastForumList= res.data.obj.list;
                    }else {
                        this.$message.error(res.data.msg)
                    }
                })
            },

            changeType(t){
                this.$router.push("Forum?typeId="+t.id);
            },
            sixin(){
                this.$message.info('敬请期待')
                // if(this.author.id==this.lander.uid){
                //     this.$message.error("不能自己给自己发起会话");
                //     return;
                // }
                // let o={ tuid:this.author.id,uid:this.lander.uid,token:this.lander.token}
                // this.loading = this.$loading({
                //     lock: true,
                //     text: "创建会话...",
                //     spinner: "el-icon-loading",
                //     background: "rgba(0, 0, 0, 0.5)",
                // });
                // creatChatRoom( o).then((res) => {
                //     this.loading.close();
                //     dealResult(res.data);
                //     if (res.data.status == 1) {
                //         this.$router.push('Chat?roomno='+res.data.obj.roomNo)
                //     }else {
                //         this.$message.error(res.data.msg)
                //     }
                // })
            },
            sendMessage(msg){
                let that = this;
                console.log(that.$messageSocket.ws);
                if (that.$messageSocket.ws && that.$messageSocket.ws.readyState == 1) {
                    console.log("发送信息", msg);
                    that.$messageSocket.ws.send(msg);
                }else{
                    that.ws = new WebSocket(messageSocketUrl+this.lander.uid);
                    that.$messageSocket.setWs(that.ws);
                    setTimeout(()=>{
                        console.log("setTimeout发送信息", msg);
                        that.$messageSocket.ws.send(msg);
                    },2000)
                }
            },
            fixedmenu(){

                let that=this;
                window.onscroll = function () {


                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight  ;
                    let wh = document.documentElement.clientHeight  ;

                    if(that.webW){
                        let JfLeftMenu=document.getElementById('JfLeftMenu');

                        let JfRightMenu=document.getElementById('JfRightMenu');




                        that.LeftMenuWidth=JfLeftMenu.offsetWidth;
                        that.RightMenuWidth=JfRightMenu.offsetWidth;
                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight=JfLeftMenu.offsetHeight;
                        let leftTop=JfLeftMenu.offsetTop;
                        if(t>leftTop+leftHeight){
                            that.fixedLeftmenu=true;
                        }else{
                            that.fixedLeftmenu=false;
                        }


                        let rightHeight=JfRightMenu.offsetHeight;
                        let rightTop=JfRightMenu.offsetTop;

                        if(t>rightTop+rightHeight+50){
                            that.fixedRightmenu=true;
                        }else{
                            that.fixedRightmenu=false;
                        }
                    }


                    //滚动条到底部加载数据
                    if(t+wh>=h-100 && that.openAutoReflashComments && !that.commentDataFinish){


                         if(that.tableData.length>0 ){

                             if( !that.commentliLoading)that.getCommentPage(that.tableData[0],0);
                         }
                    }

                    //出现回到顶部按钮
                    if(t > wh) that.scrolltop=true;
                    else that.scrolltop=false;

                }

            },
            getVideoplayitemWidth(){
                let mainDiv = document.getElementById('mainDiv');
                let mainDivWidth= mainDiv.clientWidth   || mainDiv.clientWidth;
                this.videoplayitemWidth=mainDivWidth/8-4;



            },
            colseBianji(){
                this.needLoad=false;
                this.needLoadComment=false;
                this.getForumDetailFunc();
            }

        }, mounted() {
            this.maxvideoarea=maxvideoarea;
            this.maxvideonum=maxvideonum;
            this.maximgnum=maximgnum;

            vm=this;
            document.documentElement.scrollTop=0;
            document.body.scrollTop=0;


            let windowWidth=getWindowWidth();
            this.webW=(windowWidth>=1000?true:false);

            if(windowWidth>this.jiugonggeWidth){
                this.jiugonggeItemWidth=this.jiugonggeWidth/forumImgGongge-4 ;
            }else{
                this.jiugonggeItemWidth=(windowWidth-30)/forumImgGongge-4 ;
            }



            this.lander = JSON.parse(this.$store.state.logininfo);
            if(this.lander.state!='1'){
                this.nouse=true;
                this.$message.error("你已被禁言");
            }



            //固定左右菜单
            this.fixedmenu();

            if(this.$route.query.id!=undefined) this.id = this.$route.query.id;
            if(this.$route.query. goPosition=='comment')  this.goPosition='comment';
            else this.goPosition='top';



            this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/common/upimg?type=forum_detail&uid=' + this.lander.uid + "&token=" + this.lander.token+"&id="+this.id;
            this.FILE_ACTION2 = process.env.VUE_APP_API_ROOT + '/common/upimg?type=forum_video&uid=' + this.lander.uid + "&token=" + this.lander.token+"&id="+this.id;



            this.needLoad=true;
            this.getForumDetailFunc();



        },
        watch:{
            $route:function(value){
                document.documentElement.scrollTop=0;
                document.body.scrollTop=0;


                if(this.$route.query.goPosition=='comment')  this.goPosition='comment';
                else this.goPosition='top';
                if(value.query.id!=undefined){
                    this.id=value.query.id;
                    this.needLoad=true;
                    this.getForumDetailFunc();
                }
                this.fixedmenu();

            }
        },
        activated() {



            //固定左右菜单
            this.fixedmenu();




        },
        deactivated() {
            this.closeYlVideodialog();
            this.stopvideo();
        }


    };
</script>
<style scoped>
    /deep/ .ql-container {
        min-height:34.71px;
    }
    .woo-box-flex {
        display: flex;
        margin: 0 0 -25px 0;
    }
    .woo-avatar-main {
        border-radius: 50%;
        display: inline-block;
        font-size: 1rem;
        height: 2.5em;
        position: relative;
        width: 2.5em;
        margin: 0 10px 0 0;
    }
    .Tool_check {
    position: relative;
    top: -10px;
    right: 13px;
    float: right;
    }
   .woo-button-main {
       width: 60px;
       height: 30px;
       border-radius: 17px;
       background-color: #ff8200;
       color: #fff;
       border:0;
   }
    .woo-box-item-flex {
        flex: 1;
    }
    .fpledit {
      display: flex;
      width: 100%;
      flex-direction:column-reverse
    }
    .fpledit /deep/ .ql-container.ql-snow {
      border:0;
    }
    .fpledit /deep/ .ql-toolbar.ql-snow {
      border:0;
      background: none;
    }
    .fpledit /deep/ .ql-toolbar.ql-snow .ql-fill{
      color:red;
    }
    .fpledit /deep/ .ql-toolbar.ql-snow .ql-formats .ql-emoji {
      height: 3.5rem;
    }
    .fpledit /deep/ .ql-container .ql-editor {
        padding:6px 11px;
        font-size: 16px;
        word-break:break-all;
        white-space:normal; 
    }



    .fpledit /deep/ .ql-container {
        background: #ffffff;
        
        padding: 0 0;
        width: 100%;
    }
    .fpledit /deep/ .ql-toolbar {
        width:50px;
        height:40px;
        margin-left: 10px;
        background: #ffffff;
        
    }
    

    a {
        text-decoration: none
    }

    .el-checkbox-group {
        font-size: 13px;
    }

    .pcavatar {
        width: 30px;
        height: 30px;
        border-radius: 50%
    }
    .pcname {
        font-size: 14px;
        padding-left: 12px;
        font-weight: bold
    }
    .phoneavatar {
        width: 23px;
        height: 23px;
        border-radius: 50%;
    }
    .phonename {
        font-size: 12px;
        padding-left: 10px
    }
    .pctitle {
        font-size:20px;
    }
    .phonetitle {
        font-size: 18px;
    }
    /deep/ input[type=file] {
        display: none;
    }

    .riqixzq{transform: scale(0.9);margin-left: -20px;}
    .riqixzq /deep/ .el-date-range-picker__content{clear: both;width: 100%;}





    .heiseplayertck  /deep/ .el-dialog{background-color: #000;}
    .heiseplayertck  /deep/ .el-dialog__title{ color: #f3f3f3;}
    .heiseplayertck  /deep/ .el-dialog__close { color: #fff;}

</style>
<style>
    .msgboxgf{
        max-width: 420px;
        width: 100%;

    }

</style>
